// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EnergyLabel_wrapper__36Jlv","buttons":"EnergyLabel_buttons__2c4vm"};